import React, { useContext, useEffect, useState } from "react";
import Product1 from "./Product1"
import Product2 from "./Product2"
import Product3 from "./Product3"
import { AppContext } from "contexts/AppContext";
import { Modal } from "react-bootstrap";
import ContentNormal from "components/elements/ContentNormal";
import { callAPI } from "utils/API";
import Coupon from "./Coupon";
import { useParams } from "react-router-dom";

function Product() {
  const { defaultTheme, brandData, basket, userData, accessibleShops } = useContext(AppContext)
  const { ProductID } = useParams()
  const { enableOnePointUsers = false } = brandData?.features
  const [showBasketError, setShowBasketError] = useState(false)
  const [freightInfo, setFreightInfo] = useState(null)
  const [productInfo, setProductInfo] = useState(null)

  const ShopIDs = accessibleShops.map(item => item.ShopID)

  const checkBasketForOnePointUser = () => {
    let allow = false
    if (!enableOnePointUsers) allow = true
    if (!basket?.length && !!userData?.walletAmountPoints) allow = true
    if (!!enableOnePointUsers && !!basket?.length) {
      allow = (userData?.walletAmountPoints || 0) > (basket?.length || 0)
    }
    setShowBasketError(!allow)
    return allow
  }

  const fetchProductDetails = async () => {
    if (!ProductID || !ShopIDs) return
    let productInfo = await callAPI(`/product/${ProductID}`, "GET", { query: { ShopIDs } });
    if (productInfo && productInfo.length) {
      setProductInfo(productInfo)
    }

    return
  }

  const fetchFreightIntervals = async () => {
    const response = await callAPI('/brand/freightIntervals')
    if (response && Object.keys(response).length) {
      setFreightInfo({
        enableDropshipFreightPrice: response.enableDropshipFreightPrice,
        enableFreightPriceInterval: response.enableFreightPriceInterval,
        freightIntervals: response.freightIntervals
      })
    }
  }

  useEffect(() => {
    fetchProductDetails()
  }, [ProductID, accessibleShops]);

  useEffect(() => {
    fetchFreightIntervals()
    fetchProductDetails()
  }, [])

  const selectProduct = {
    "ThemeONE": productInfo?.length && productInfo[0].isCoupon
      ? <Coupon checkBasketForOnePointUser={checkBasketForOnePointUser} productInfo={productInfo} />
      : <Product1 checkBasketForOnePointUser={checkBasketForOnePointUser}  freightInfo={freightInfo} productInfo={productInfo} />,
    "ThemeTWO": <Product2 checkBasketForOnePointUser={checkBasketForOnePointUser}  freightInfo={freightInfo}/>,
    "ThemeTHREE": <Product3 checkBasketForOnePointUser={checkBasketForOnePointUser}  freightInfo={freightInfo}/>,
  }

  return <>
    {selectProduct[defaultTheme]}
    <Modal show={showBasketError} onHide={() => setShowBasketError(false)} style={{ margin: 'auto' }} centered>
      <Modal.Header className="pb-0 border-0" closeButton style={{ fontSize: 9 }} />
      <Modal.Body className="pt-0">
        <div className='product-variations' style={{ marginTop: 20, marginBottom: 48 }}>
          <ContentNormal translationKey="_ERROR_ONEPOINT_USER_INSUFFICIENT_BALANCE_" fallbackText="You have already added items to your cart for the points you had. 
                  Please remove items from the cart to add this item." />
        </div>
      </Modal.Body>
    </Modal>
  </>
}

export default Product;
